import { createContext } from 'react'
import { Alert, Info } from '../../icons'
import { AlertContextType, ColorSchemeType } from './types'

export const ColorSchemes: ColorSchemeType = {
  info: {
    textColor: 'blue1000',
    backgroundColor: 'blue0200',
    icon: Info
  },
  warning: {
    textColor: 'yellow1000',
    backgroundColor: 'yellow0200',
    icon: Alert
  },
  error: {
    textColor: 'red1000',
    backgroundColor: 'red0200',
    icon: Alert
  }
}

export const AlertContext = createContext<AlertContextType>({
  status: 'info',
  colorScheme: ColorSchemes.info
})
